<template>
  <div>
    <ContentHeader path-set-type="append" :gameplan-nav="true" />
    <div class="content-wrapper" v-loading="loading">
      <el-row>
        <div class="card-top is-hover-shadow">
          <div class="card-top-left">
            <div class="top">
              <span>{{ this.themeInfo.themeName }}</span>
            </div>
            <div class="bottom">
              <div class="left">
                活动PR： {{ this.themeInfo.gpPrDTO.prNumber }}-{{
                  this.themeInfo.gpPrDTO.prName
                }}
              </div>
              <div class="right">{{ this.themeInfo.gpPrDTO.brandName }}</div>
            </div>
          </div>
          <div class="card-top-right">
            <div class="text-time">
              <span>活动执行时间：</span>
              <span>{{ getTime(this.themeInfo.themeStartTime) }}</span>
              <span style="margin: 0 10px">至</span>
              <span>{{ getTime(this.themeInfo.themeEndTime) }}</span>
            </div>
          </div>
        </div>
        <el-col :span="6" class="content-left">
          <div class="trade-container">
            <el-card class="trade-nav-panel">
              <div slot="header" class="clearfix">
                <span class="panel-header">活动渠道</span>
              </div>
              <el-menu
                :default-active="themeChannelCode"
                active-text-color="#101010"
                text-color="#999999"
              >
                <!-- <el-menu-item index="/gameplan/activityPhoto-channel/all">
                  <span slot="title">全部</span>
                </el-menu-item>
                <el-menu-item index="/gameplan/activityPhoto-channel/cross">
                  <span slot="title">Cross-Channel</span>
                </el-menu-item>
                <el-menu-item index="/gameplan/activityPhoto-channel/cr">
                  <span slot="title">CR</span>
                </el-menu-item>
                <el-menu-item index="/gameplan/activityPhoto-channel/club">
                  <span slot="title">Club</span>
                </el-menu-item>
                <el-menu-item index="/gameplan/activityPhoto-channel/ktv">
                  <span slot="title">KTV</span>
                </el-menu-item>
                <el-menu-item index="/gameplan/activityPhoto-channel/bar">
                  <span slot="title">bar</span>
                </el-menu-item> -->

                <el-menu-item index="all" @click="clickMenu('all')">
                  <span slot="title">全部</span>
                </el-menu-item>
                <el-menu-item
                  v-for="(value, key) in themeChannelMap"
                  :key="key"
                  :index="key"
                  @click="clickMenu(key)"
                >
                  <span slot="title">{{ value }}</span>
                </el-menu-item>
              </el-menu>
            </el-card>
          </div>
        </el-col>
        <el-col :span="18" class="content-right">
          <div class="card-box">
            <div
              class="card is-hover-shadow"
              v-for="item in cardData"
              :key="item.activityId"
            >
              <div class="first">
                <div class="first-left">
                  <span>活动渠道: </span>
                  <span v-if="item.themeDetail">{{
                    item.themeDetail.themeChannelName
                  }}</span>
                </div>
                <div>
                  <!-- v-for="(i) in item.gpThemeDetailDTO.themeStyleName" -->
                  <div class="first-center">
                    <div class="first-center-item" v-if="item.themeDetail.themeStyleName">
                      <span>活动形式：</span>
                      <span>{{item.themeDetail.themeStyleName}}</span>
                    </div>
                    <div class="first-center-item" v-if="item.themeDetail.themeLevelName">
                      <span>级别：</span>
                      <span>{{item.themeDetail.themeLevelName}}</span>
                    </div>
                  </div>
                </div>

                <div class="first-right" v-if="item.themeDetail">
                  <span>{{
                    item.themeDetail.needVerify == 1 ? "需要场勘" : "不需要场勘"
                  }}</span>
                  <span>/</span>
                  <span>{{
                    item.themeDetail.needConstruct == 1
                      ? "需要搭建"
                      : "不需要搭建"
                  }}</span>
                </div>
              </div>
              <div class="second" v-if="item.themeDetail">
                <div class="second-left">
                  <span style="margin-right: 5px">是否需要SPR: </span>
                  <span>{{ item.themeDetail.needSpr == 1 ? "是" : "否" }}</span>
                </div>
                <!-- <div class="second-left">
                  <span style="margin-right: 5px">是否需要督导打卡: </span>
                  <span>{{ item.themeDetail.needSupervisor == 1 ? "是" : "否" }}</span>
                </div> -->
              </div>
              <div class="second">
                <div class="second-right">
                  <span style="margin-right: 5px">装饰点位：</span>
                  <span>{{
                    getChannel(item.themeDetail.themeDecorates, "、")
                  }}</span>
                </div>
              </div>
              <div class="third">
                <!-- <span>IGNITE查询规则：</span>
                <span class="right10">(IGNITE状态:</span>
                <span v-if="item.themeDetail">{{
                  getOptionsName(
                    item.themeDetail.igniteRuleObj.igniteStatus,
                    "、",
                    igniteOptions.igniteStatus
                  )
                }}</span>

                <span class="right15">;</span>
                <span class="right10">售点状态:</span>
                <span v-if="item.themeDetail">{{
                  getOptionsName(
                    item.themeDetail.igniteRuleObj.openStatus,
                    "、",
                    igniteOptions.openStatus
                  )
                }}</span>

                <span class="right15">;</span>
                <span class="right10">渠道设置:</span>
                <span v-if="item.themeDetail">{{
                  getOptionsName(
                    item.themeDetail.igniteRuleObj.channel,
                    "、",
                    igniteOptions.channel
                  )
                }}</span>

                <span class="right15">;</span>
                <span class="right10">业态:</span>
                <span v-if="item.themeDetail">{{
                  getOptionsName(
                    item.themeDetail.igniteRuleObj.bizForm,
                    "、",
                    igniteOptions.bizForm
                  )
                }}</span>

                <span class="right15">;</span>

                <span class="right10">档次:</span>
                <span v-if="item.themeDetail">{{
                  getOptionsName(
                    item.themeDetail.igniteRuleObj.pocGrade,
                    "、",
                    igniteOptions.pocGrade
                  )
                }}</span>

                <span class="right15">;</span>
                <span class="right10">销售潜力:</span>
                <span v-if="item.themeDetail">{{
                  getOptionsName(
                    item.themeDetail.igniteRuleObj.salesVolume,
                    "、",
                    igniteOptions.salesVolume
                  )
                }}</span>
                <span>)</span> -->
              </div>
              <div class="fourth" v-if="item.themeDetail.statisticVO">
                <span>提报信息：</span>
                <!-- <span>已提报：</span>
                <span>{{ item.themeDetail.statisticVO.submitQty }}场</span>
                <span style="margin: 0px 5px">/</span> -->
                <span>已通过：</span>
                <span>{{ item.themeDetail.statisticVO.passedQty }}场</span>
                <span style="margin: 0px 5px">/</span>
                <span>审核中：</span>
                <span>{{ item.themeDetail.statisticVO.waitApproveQty }}场</span>
                <span style="margin: 0px 5px">/</span>
                <span>未提报：</span>
                <span>{{ item.themeDetail.statisticVO.waitSubmit }}</span>
                <span>场</span>
              </div>
              <div class="last" v-if="item.themeDetail.statisticVO">
                <div class="last-left">
                  <!-- <span class="black">售点信息：已提报：</span>
                  <span class="blue"
                    >{{ item.themeDetail.statisticVO.submitQty }}场</span
                  >
                  <span class="line">|</span> -->
                  <span class="black">活动照片待审批：</span>
                  <span class="blue"
                    >{{ item.themeDetail.statisticVO.evidence }}场</span
                  >
                </div>
                <div class="last-right" @click="goApprove(item)">去审批</div>
              </div>
            </div>
          </div>
          <div v-if="cardData.length == 0">
            <!-- style="height: 50px; line-height: 50px; text-align: center" -->
            <!-- {{ loadingText }} -->
            <el-empty description="暂无数据"></el-empty>
          </div>
          <div v-if="cardData.length > 0" class="pagination">
            <el-pagination
              background
              layout="total, prev, pager, next"
              :total="queryParams.total"
              :current-page="queryParams.page"
              :page-size="queryParams.pageSize"
              @current-change="handleCurrentChange"
            />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ContentHeader from "@/components/content-header";
import gameplanApi from "../../api/gameplan";
export default {
  name: "activityPhoto-channel",
  components: {
    ContentHeader,
  },
  data() {
    return {
      queryParams: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      themeId: "",
      themeChannelCode: "",
      activityTypecode: "",
      cardData: [],
      igniteOptions: {},
      loading: false,
      loadingText: "",
      themeChannelMap: {},
    };
  },
  computed: {
    // ...mapGetters(['userInfo']),
    themeInfo() {
      const val = {
        gpPrDTO: {},
      };
      if (!this.cardData || !this.cardData.length) {
        return val;
      }
      return this.cardData[0].themeBasic;
    },
  },
  watch: {
    // $route: {
    //   handler(to, from) {
    //     let queryType = to.params.activityType;
    //     if (queryType === "all") {
    //       this.activityTypecode = "";
    //       this.themeId =
    //         this.$route.query.themeId || localStorage.getItem("photothemeId");
    //       this.queryParams.page = 1;
    //       this.getThemelist();
    //     } else if (queryType === "cross") {
    //       this.activityTypecode = "01";
    //       this.getThemelist();
    //     } else if (queryType === "cr") {
    //       this.activityTypecode = "02";
    //       this.queryParams.page = 1;
    //       this.getThemelist();
    //     } else if (queryType === "club") {
    //       this.activityTypecode = "03";
    //       this.queryParams.page = 1;
    //       this.getThemelist();
    //     } else if (queryType === "ktv") {
    //       this.activityTypecode = "04";
    //       this.queryParams.page = 1;
    //       this.getThemelist();
    //     } else if (queryType === "bar") {
    //       this.activityTypecode = "05";
    //       this.queryParams.page = 1;
    //       this.getThemelist();
    //     }
    //   },
    //   immediate: true,
    // },
  },
  created() {
    this.themeId = this.$route.query.themeId;
    this.themeChannelCode = this.$route.query.themeChannelCode;
    if (!this.themeChannelCode) {
      this.themeChannelCode = "all";
    }
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.getThemelist();
    },
    getTime(timestamp) {
      if (timestamp === 0 || timestamp == null) {
        return "";
      } else {
        var date = new Date(parseInt(timestamp)); // 时间戳为13位的话需要parseInt下
        const Y = date.getFullYear() + "-";
        const M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        const D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
        // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
        return Y + M + D;
      }
    },
    clickMenu(code) {
      this.themeChannelCode = code;
      this.queryParams.page = 1;
      this.getThemelist();
    },
    getChannel(a, b) {
      let themeChannels = a;
      let arr = themeChannels
        .map((item) => {
          return item.decorateName;
        })
        .join(b);
      return arr;
    },
    getOptionsName(a, b, g) {
      let c = a;
      let d = [];
      let e = g;
      let f = [];
      for (let i in e) {
        let obj = {};
        obj[i] = e[i];

        for (let i2 of c) {
          if (i == i2) {
            f.push(e[i]);
          }
        }
      }
      let arr = f
        .map((item) => {
          return item;
        })
        .join(b);
      return arr || '暂无';
    },
    async getThemelist() {
      // themeId:this.themeId
      const params = {
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        themeId: this.themeId || localStorage.getItem("photothemeId"),
        queryCondition: '01'
      };
      if ("all" !== this.themeChannelCode) {
        params.themeChannelCode = this.themeChannelCode;
      }
      this.loading = true;
      let res = await gameplanApi.getGamepalnChannellist(params);
      this.loading = false;
      if (res.data.resultCode === "0") {
        let pageData = res.data.resultData.pageInfo;
        this.queryParams.total = Number(pageData.totalCounts);
        this.cardData = res.data.resultData.detailList || []
        if (this.themeChannelCode === 'all') {
          this.themeChannelMap = res.data.resultData.themeChannelMap || {};
        }
        if (this.cardData.length === 0) {
          this.loadingText = "未查询到数据";
        }
      } else {
        console.log("接口error");
      }
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getThemelist();
    },
    // 去审批
    goApprove(item) {
      this.$router.push({
        path: "/gameplan/activityPhoto-salePlace",
        query: {
          themeId: item.themeDetail.themeId,
          themeDetailId: item.themeDetail.themeDetailId
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .trade-nav-panel {
      width: 80%;
      min-height: 400px;
      margin: 0 auto;
      background: $base-white;
    //   .el-menu-item:last-child{
    //     border-bottom: 0;
    //   }
      ::v-deep .el-card__header {
        height: 70px;
        line-height: 35px;
      }

      ::v-deep .el-card__body {
        padding: 0;
      }

      .panel-header {
        font-size: 16px;
        font-weight: 700;
        color:#CD1231;
      }
      ::v-deep .el-menu {
        border-right: 0;
      }
      ::v-deep .el-menu-item {
        border-bottom: 1px solid $base-grey5;
      }

      ::v-deep .el-menu-item.is-active {
        color: $base-red;
      }
    }
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .card-top {
        width: 94%;
        margin-left: 2.5%;
        line-height: 20px;
        border-radius: 10px;
        padding: 10px 20px;
        margin-bottom: 30px;
        font-size: 14px;
        text-align: center;
        background-color: #FFFFFF;
        color: #101010;
        font-family: Roboto;
        display: flex;
        justify-content: flex-start;
        .card-top-left {
            .top {
                line-height: 29px;
                color: #101010;
                font-size: 20px;
                font-weight: 600;
                text-align: left;
                font-family: SourceHanSansSC-medium;
                margin-bottom: 5px;
            }
            .bottom {
                display: flex;
                justify-content: flex-start;
                .left {
                    font-size: 16px;
                    margin-right: 11px;
                    line-height: 24px;
                }
                .right {
                    width: 72px;
                    line-height: 20px;
                    border-radius: 4px;
                    margin-top: 1px;
                    font-size: 14px;
                    background-color: #FFFFFF;
                    color: #539EFE;
                    border: 1px solid #539EFE;
                    text-align: center;
                    font-family: Microsoft Yahei;
                }
            }
        }
        .card-top-right {
            flex: 1;
            text-align: right;
            height: 20px;
            line-height: 20px;
            margin-top: 40px;
            color: #999999;
        }
      }

      .content-right {
        height: 100%;
        box-sizing: border-box;
        a {
          text-decoration: none;
          color: #000;
        }
        .search {
            .searchForm {
                width: 100%;
                .item {
                    width:120px;
                }
                .item-btn {
                    margin-left: 30px;
                }
            }
        }
        .card-box {
            .card {
                padding:10px 10px;
                background-color: #FFFFFF ;
                border-radius: 10px;
                font-size: 14px;
                margin-bottom: 20px;
                .first {
                    display: flex;
                    justify-content: flex-start;
                    line-height: 33px;
                    .first-left {
                        color: #101010;
                        text-align: left;
                        font-family: SourceHanSansSC-medium;
                        margin-right: 10px;
                        font-size: 16px;
                        font-weight: 600;
                    }
                    .first-center {
                        display: flex;
                        .first-center-item {
                            height: 19px;
                            line-height: 19px;
                            margin-top: 3px;
                            padding: 3px 5px;
                            text-align: center;
                            border-radius: 4px;
                            font-family: Microsoft Yahei;
                            border: 1px solid #CD1231;
                            background-color: #FFFFFF;
                            color: #CD1231;
                            margin-right: 5px;
                        }

                    }
                    .first-right {
                        flex: 1;
                        text-align: right;
                        color: #CD1231;
                        font-size: 16px;
                        font-weight: 600;
                    }
                }
                .second {
                    display: flex;
                    justify-content: flex-start;
                    line-height: 26px;
                    font-size: 13px;
                    text-align: left;
                    color: #101010;
                    .second-left {
                        margin-right: 48px;
                    }
                    .second-right {
                      flex: 1;
                    }
                }
                .third {
                    line-height: 27px;
                    color: #999999;
                    font-size: 13px;
                    text-align: left;
                    .right10 {
                        margin-right: 10px;
                    }
                    .right15 {
                        margin: 0 5px;
                    }
                }
                .fourth {
                    line-height: 27px;
                    color: #101010;
                    font-size: 14px;
                    text-align: left;
                }
                .last {
                    display: flex;
                    justify-content: flex-start;
                    line-height: 33px;
                    font-size: 16px;
                    text-align: left;
                    color: #101010;
                    .last-left {
                        flex: 1;
                        .line{
                        color: #999999;
                        margin: 0 5px;
                        }
                        .blue {
                            color:#409EFF;
                        }
                    }
                    .last-right{
                        width: 100px;
                        border-radius: 4px;
                        font-size: 14px;
                        text-align: center;
                        font-family: Microsoft Yahei;
                        color: #CD1231;
                        border: 1px solid #CD1231;
                        margin-left: 190px;
                        cursor: pointer;
                    }
                }
            }
        }
        .pagination {
            position: relative;
            bottom: 0;
            text-align: center;

        }
      }
      .content-left {
        padding-right: $content-middle;
      }
    }
</style>
